import React, { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
// import { useDispatch } from 'react-redux';
import useFetch from 'use-http';
import { AppContext } from 'src/providers/AppContextProvider';
import { IAppContextState } from 'src/reducers/AppContext';
// import { push } from 'connected-react-router';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
// import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import RHFLegend from 'src/components/controls/tempRHFControls/RHFLegend';
import AltSubCode from 'src/models/projectSettings/altSubCode/AltSubCode';
import { AnyObject } from 'final-form';
import Dialog from 'src/components/common/Dialog.redesign';
import LoadingSpinner from 'src/components/common/LoadingSpinner';
import Card from 'src/components/common/Card.redesign';
import CardContainer from 'src/components/common/CardContainer.redesign';

interface IAltSubCodeSectionProps {
    subCodeId: number;
}

const AltSubCodeSection = (props: IAltSubCodeSectionProps) => {
    const { register, handleSubmit, errors, reset } = useForm();
    // const dispatch = useDispatch();
    const { get, response, put, post } = useFetch();
    const appContext = useContext<IAppContextState>(AppContext);

    const [projectASC, setProjectASC] = useState<Array<AltSubCode>>(undefined);
    const [formData, setFormData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [altSubCode, setAltSubCode] = useState(undefined);

    useEffect(() => {
        getProjectASC();
    }, []);

    useEffect(() => {
        reset(formData);
    }, [formData]);

    const getProjectASC = async () => {
        setIsLoading(true);
        const result = await get(
            `/v1.0/clients/${appContext.clientNumber}/Projects/${appContext.projectNumber}/subCode/${props.subCodeId}/altSubCodes`
        );

        if (response.ok) {
            setProjectASC(result);
            setIsLoading(false);
        }
    };

    const prepFormData = (asc: AltSubCode) => {
        let data: AltSubCode = {
            id: asc ? asc?.id : 0,
            name: asc ? asc?.name : '',
            afeNo: asc ? asc?.afeNo : 0,
            costCenterCode: asc ? asc?.costCenterCode : 0,
            clientAccountingCode: asc ? asc?.clientAccountingCode : 0,
            codeNumber: asc ? asc?.codeNumber : 0,
            fieldLookupId: asc ? asc?.fieldLookupId : 0,
        };

        setAltSubCode(data);
        setFormData(data);
    };

    // Resets data of componet so no "previous" data would overlap
    const resetComponentData = () => {
        let defaultASC: AltSubCode = {
            id: null,
            fieldLookupId: null,
            codeNumber: null,
            name: null,
            afeNo: null,
            costCenterCode: null,
            clientAccountingCode: null,
        };

        prepFormData(defaultASC);
        reset();
        setAltSubCode(undefined);
    };

    // Render a list of Alt Sub Codes
    const renderAltSubCodes = () => {
        if (!isLoading && projectASC?.length > 0) {
            return projectASC?.map((asc: AltSubCode) => {
                const handleEditAltSubCode = () => {
                    prepFormData(asc);
                    setShowForm(true);
                };

                return (
                    <Card
                        badge={asc?.id ? `${appContext.clientNumber} . ${appContext.projectNumber} . ${props?.subCodeId} . ${asc?.id}` : ''}
                        key={asc?.id}
                        style={{ margin: 'auto 0px', borderTop: '1px solid #ccc' }}
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-between', margin: '0 5rem 1rem 5rem' }}>
                            <div>{`Alt Sub Code ${asc?.id}`}</div>
                            <div>
                                <Button text="Edit Sub Code" type="submit" onClick={handleEditAltSubCode} />
                            </div>
                        </div>
                    </Card>
                );
            });
        }

        if (!isLoading && projectASC?.length === 0) {
            return <div style={{ textAlign: 'center' }}>No Alt Sub Codes Available.</div>;
        }

        return isLoading && <LoadingSpinner />;
    };

    const handleAddAltSubCode = () => {
        setShowForm(true);
    };

    const handleCancelBtn = () => {
        setShowForm(false);
        resetComponentData();
    };

    // Render form to edit or add a new Alt Sub Code
    const renderForm = () => {
        return (
            <form onSubmit={handleSubmit(onSubmit)}>
                <RHFLegend title="Alt-Sub-Code Billing" />
                <div style={{ marginTop: '1rem', paddingBottom: '2rem', gap: '7rem' }}>
                    <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '1rem', justifyContent: 'center' }}>
                        <div style={{ width: '150px' }}>
                            <RHFInputBox name="name" label="Name" register={register} errors={errors} />
                        </div>
                        <div style={{ width: '150px' }}>
                            <RHFInputBox name="afeNo" label="AFE No" register={register} errors={errors} />
                        </div>
                        <div style={{ width: '150px' }}>
                            <RHFInputBox name="costCenterCode" label="Cost Center Code" register={register} errors={errors} />
                        </div>
                        <div style={{ width: '150px' }}>
                            <RHFInputBox name="clientAccountingCode" label="Client Accounting Code" register={register} errors={errors} />
                        </div>
                    </div>
                </div>

                <div style={{ display: 'flex', gap: '3rem', marginTop: '2rem' }}>
                    <Button text="Submit" intent="primary" type="submit" />
                    <Button text="Cancel" intent="secondary" type="button" onClick={handleCancelBtn} />
                </div>
            </form>
        );
    };

    const createRecord = async (data: Object) => {
        const result = await post(
            `/v1.0/clients/${appContext.clientNumber}/Projects/${appContext.projectNumber}/subCode/${props.subCodeId}/altSubCodes`,
            data
        );
        console.log('unit settings');

        if (response.ok) {
            console.log('🤯 ~ file: AltSubCodeSection.tsx:79 ~ createRecord ~ result:', result);
            resetComponentData();
            getProjectASC();
        }
    };

    const updateRecord = async (data: Object) => {
        const result = await put(
            `/v1.0/clients/${appContext.clientNumber}/Projects/${appContext.projectNumber}/subCode/${props.subCodeId}/altSubCodes`,
            data
        );
        console.log('unit settings');

        if (response.ok) {
            console.log('result', result);
            resetComponentData();
            getProjectASC();
        }
    };

    // Format submitted data to create or update an Alt Sub Code
    const formatData = (data: AnyObject) => {
        let newData: AltSubCode = {
            id: 0,
            name: '',
            afeNo: 0,
            costCenterCode: 0,
            clientAccountingCode: 0,
            codeNumber: 0,
            fieldLookupId: 0,
        };
        newData.id = altSubCode?.id ? parseInt(altSubCode?.id + '', 10) : 0;
        newData.name = data.name ? data.name : '';
        newData.afeNo = data.afeNo ? parseInt(data.afeNo + '', 10) : 0;
        newData.costCenterCode = data.costCenterCode ? parseInt(data.costCenterCode + '', 10) : 0;
        newData.clientAccountingCode = data.clientAccountingCode ? parseInt(data.clientAccountingCode + '', 10) : 0;
        newData.fieldLookupId = props?.subCodeId ? parseInt(props?.subCodeId + '', 10) : 0;

        return newData;
    };

    const onSubmit = (values: AnyObject) => {
        setShowForm(false);

        const newValues = formatData(values);

        if (!newValues.id || newValues.id === 0) {
            createRecord(newValues);
        } else {
            updateRecord(newValues);
        }
    };

    return (
        <Dialog title="Add Alt Sub Code">
            <div>
                <CardContainer style={{ overflow: 'auto', maxHeight: '150px' }}>{renderAltSubCodes()}</CardContainer>
                {/* <div style={{ backgroundColor: '#ffff', maxHeight: '100px', overflow: 'auto', marginBottom: '3rem', padding: '0 2rem' }}>
                    {renderAltSubCodes()}
                </div> */}
                <div>
                    {showForm && renderForm()}
                    {!showForm && (
                        <div style={{ marginTop: '1rem' }}>
                            <Button text="Add Alt Sub Code" intent="primary" type="button" onClick={handleAddAltSubCode} />
                        </div>
                    )}
                </div>
            </div>
        </Dialog>
    );
};

export default AltSubCodeSection;



// WEBPACK FOOTER //
// ./src/components/project/sections/AltSubCodeSection.tsx